import type { Timelog } from '@/modules/attendance/domain/entities/Timelog';
import { pad, isoDate, parsePgDateTime } from '@/shared/utils/datetime';

const CSV_HEADER = 'code;date;timelog;structure;access_type_timelog;description';

/** Quotes a field only when it contains the delimiter, a quote, or a newline. */
function toCsvField(value: string): string {
  if (/[;"\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function toCsvRow(tl: Timelog, downloadedFromLabel: string): string {
  const d = parsePgDateTime(tl.datetime);
  const date = isoDate(d);
  const time = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  const fields = [
    tl.employee?.code ?? '',
    date,
    time,
    tl.structureCode ?? '',
    String(tl.accessType),
    downloadedFromLabel,
  ];
  return fields.map(toCsvField).join(';');
}

/** Builds and downloads a `;`-delimited CSV of the given timelogs via a client-side blob. */
export function exportTimelogsCsv(timelogs: Timelog[]): void {
  // Per support's request, the description column no longer carries each timelog's own
  // observation — it's replaced with a fixed "downloaded from" label identifying the kiosk
  // that generated the file, repeated on every row. `mi_enrolled_device_model` holds
  // Device.name from enrollment (see useEnrollDeviceOnLogin.ts) despite its key name.
  const deviceName = localStorage.getItem('mi_enrolled_device_model') || 'Dispositivo desconocido';
  const downloadedFromLabel = `DESCARGADO DESDE: ${deviceName}`.toUpperCase();
  const csv = [CSV_HEADER, ...timelogs.map((tl) => toCsvRow(tl, downloadedFromLabel))].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const now = new Date();
  const time = `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
  const a = document.createElement('a');
  a.href = url;
  a.download = `marcajes_${deviceName}_${isoDate(now)}_${time}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
